module.exports = __webpack_public_path__ + "static/media/ambigram.7349fe15.jpg";